// Constantes utilizadas pelo componente Menu

/**
 * Largura do drawer quando expandido
 */
export const DRAWER_WIDTH = 280;

/**
 * Largura do drawer quando colapsado
 */
export const COLLAPSED_DRAWER_WIDTH = 72;

/**
 * Altura do header/AppBar
 */
export const HEADER_HEIGHT = 64;
